/* THE PICKER (Part24, owner 2026-08-29: "perfect the governorates dropdown to our own native one like the calendar on the gift
   card page; open-source official patterns"). THE CALENDAR's sibling: a trigger styled as THE FIELD, THE RISE opening a paper
   list. The WAI-ARIA APG "Select-Only Combobox" pattern, no library: the trigger is the combobox (role=combobox,
   aria-haspopup=listbox, aria-expanded), the panel a listbox of options, focus stays on the trigger and aria-activedescendant
   names the active row. Keys: ArrowUp/Down a row, Home/End the ends, PageUp/PageDown ten rows, Enter/Space picks, Escape
   closes and keeps, Tab closes and keeps; typing letters jumps to the first option that starts with them (a buffer for a
   moment; the same letter again cycles). One tap on a row picks and closes; a tap outside closes.
   Contract: <div data-svnty-picker data-placeholder="Choose a governorate" data-picker-title="Governorate">
               <input type="hidden" data-picker-value name="...">
               <button type="button" class="svnty-field svnty-picker__trigger" data-picker-trigger aria-expanded="false" aria-controls="ID">
                 <span data-picker-label></span><span class="svnty-picker__chev" aria-hidden="true">...</span></button>
               <div class="svnty-picker__rise" data-picker-rise aria-hidden="true"><div class="svnty-picker__rise-inner">
                 <ul class="svnty-picker" id="ID" role="listbox" data-picker-list></ul></div></div>
               <template data-picker-check>{% render 'svnty-icon', name: 'check', size: 16 %}</template>
               <template data-picker-close>{% render 'svnty-icon', name: 'close', size: 20 %}</template>
             </div>
   Options come from JS: root.svntyPicker.setOptions([{value, label, hint, group}]) · setValue(value) (silent) · getValue() · getLabel()
   · open() · close() · setDisabled(bool). A pick raises `svnty:picker:change` (detail {value, label}) on the root.
   Multi-instance; re-binds on shopify:section:load; a root built later is bound with window.SVNTYPicker.setup(root).

   P27-7 (the owner's order of 2026-10-09: "regroup the reasons so nothing is cut or faded"):
     THE GROUPS   an option may name its group; each group opens with a head that stays on top of the list while its rows scroll
                  under it (sticky). The heads are words, never options: the keys and the taps walk the options only.
     THE FIT      the open list never runs past the screen: its height is the room under the field (at least 180 px, at most
                  the list itself), and it scrolls inside.
     THE SHEET    on a phone (a coarse pointer, under 750 px wide or 500 px tall), a list taller than 60 % of the screen opens as
                  the house sheet instead: a door hung from the header (THE STATUS BAR law), a paper page with the title and
                  the close, the same list inside it, the page behind it inert. Escape, the close and a pick shut it. */
(function () {
  var PAGE = 10, TYPE_MS = 500;
  var uid = 0;
  var ROW_H = 44, HEAD_H = 32, PAD = 16;

  function phone() {
    try { return window.matchMedia('(pointer: coarse) and (max-width: 749px), (pointer: coarse) and (max-height: 500px)').matches; } catch (e) { return false; }
  }

  function setup(root) {
    if (!root || root.dataset.pickerBound) return;
    root.dataset.pickerBound = '1';
    var input = root.querySelector('[data-picker-value]');
    var trigger = root.querySelector('[data-picker-trigger]');
    var rise = root.querySelector('[data-picker-rise]');
    var list = root.querySelector('[data-picker-list]');
    var riseInner = rise ? (rise.querySelector('.svnty-picker__rise-inner') || rise) : null;
    var checkTpl = root.querySelector('[data-picker-check]');
    var closeTpl = root.querySelector('[data-picker-close]');
    if (!input || !trigger || !rise || !list) return;
    var placeholder = root.dataset.placeholder || 'Choose one';
    var id = list.id || (list.id = 'svnty-picker-' + (++uid));
    var options = [], rows = [], value = String(input.value || ''), active = -1, open = false, sheet = false;
    var typed = '', typedAt = 0;

    trigger.setAttribute('role', 'combobox');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    if (!trigger.getAttribute('aria-controls')) trigger.setAttribute('aria-controls', id);
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;

    var indexOf = function (v) { for (var i = 0; i < options.length; i++) if (options[i].value === v) return i; return -1; };
    var labelOf = function (v) { var i = indexOf(v); return i === -1 ? '' : options[i].label; };
    var groupsOf = function () { var n = 0, last = null; options.forEach(function (o) { if (o.group && o.group !== last) n++; last = o.group || null; }); return n; };
    var paintTrigger = function () {
      var label = trigger.querySelector('[data-picker-label]') || trigger;
      label.textContent = value ? labelOf(value) : placeholder;
      trigger.classList.toggle('is-set', !!value);
    };
    var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; };

    var render = function () {
      list.innerHTML = ''; rows = [];
      var last = null;
      options.forEach(function (o, i) {
        if (o.group && o.group !== last) {
          var head = el('li', 'svnty-picker__group', o.group); head.setAttribute('role', 'presentation'); head.setAttribute('aria-hidden', 'true');
          list.appendChild(head);
        }
        last = o.group || null;
        var li = el('li', 'svnty-picker__opt'); li.id = id + '-opt-' + i; li.setAttribute('role', 'option');
        li.dataset.value = o.value; li.dataset.index = String(i);
        li.setAttribute('aria-selected', o.value === value ? 'true' : 'false');
        if (o.group) li.setAttribute('aria-label', o.label + ', ' + o.group);
        li.classList.toggle('is-chosen', o.value === value);
        li.classList.toggle('is-active', i === active);
        li.appendChild(el('span', 'svnty-picker__name', o.label));
        if (o.hint) li.appendChild(el('span', 'svnty-picker__hint', o.hint));
        var check = el('span', 'svnty-picker__check'); check.setAttribute('aria-hidden', 'true');
        if (checkTpl && checkTpl.content) check.appendChild(checkTpl.content.cloneNode(true));
        li.appendChild(check);
        list.appendChild(li); rows.push(li);
      });
      paintActive();
    };
    var rising = false, riseTimer = 0;   /* THE RISE state (set in setOpen) */
    var owner = function () { return sheet ? list : trigger; };   /* who carries aria-activedescendant: the field, or the list inside the sheet */
    var keepInView = function (r) {
      var head = r.previousElementSibling && r.previousElementSibling.classList.contains('svnty-picker__group') ? r.previousElementSibling : null;
      var lo = (head ? head.offsetTop : r.offsetTop), hi = r.offsetTop + r.offsetHeight;   /* nearest, inside the list only, never the page */
      var stick = list.querySelector('.svnty-picker__group') ? HEAD_H : 0;
      if (r.offsetTop - stick < list.scrollTop) list.scrollTop = Math.max(0, head ? lo : r.offsetTop - stick); else if (hi > list.scrollTop + list.clientHeight) list.scrollTop = hi - list.clientHeight;
    };
    var paintActive = function () {
      for (var i = 0; i < rows.length; i++) rows[i].classList.toggle('is-active', i === active);
      if (open && active >= 0 && rows[active]) {
        owner().setAttribute('aria-activedescendant', rows[active].id);
        if (!rising) keepInView(rows[active]);   /* mid-rise the list has no height yet: the landing scroll (see THE RISE) takes over */
      } else { trigger.removeAttribute('aria-activedescendant'); list.removeAttribute('aria-activedescendant'); }
    };
    var setActive = function (i) {
      if (!options.length) { active = -1; paintActive(); return; }
      active = Math.max(0, Math.min(options.length - 1, i));
      paintActive();
    };
    /* THE RISE (Part24, owner order): the list rises exactly as THE CALENDAR's panel (one CSS rule pair, 0.32s grid rows +
       the 0.28s fade/lift); the chosen row is scrolled into view only AFTER the rise has landed: scrolling a row inside a
       0-height list would scroll the page instead (a jump). Keyboard moves scroll at once (the list is already open). */
    var landed = function () {
      rising = false; clearTimeout(riseTimer);
      var r = rows[active]; if (!r) return;
      var top = r.offsetTop - (list.clientHeight - r.offsetHeight) / 2;
      list.scrollTop = Math.max(0, Math.min(list.scrollHeight - list.clientHeight, top));
    };
    rise.addEventListener('transitionend', function (e) { if (open && rising && e.target === rise && e.propertyName === 'grid-template-rows') landed(); });
    /* THE FIT: the room under the field, measured at the open (the list's own size estimated from its rows, never the page's) */
    var natural = function () { return options.length * ROW_H + groupsOf() * HEAD_H + PAD; };
    var fit = function (lift) {
      var b = trigger.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight || 0;
      var room = Math.floor(vh - b.bottom - 6 - 16);
      /* at the open, a field low on the screen is lifted (never past the header) so the whole list, or most of it, shows */
      var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--svnty-headstack-h')) || 0;
      var want = Math.min(natural(), Math.floor((vh - top) * 0.62));
      if (lift && room < want) {
        var by = Math.min(want - room, Math.max(0, Math.floor(b.top - top - 12)));
        if (by > 0) { try { window.scrollBy({ top: by, left: 0, behavior: 'instant' }); } catch (e) { window.scrollBy(0, by); } room += by; }
      }
      var h = Math.min(natural(), Math.max(180, room));
      list.style.maxHeight = h + 'px';
    };
    var setOpen = function (on) {
      open = on;
      rise.classList.toggle('is-open', on && !sheet);
      rise.setAttribute('aria-hidden', on && !sheet ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
      root.classList.toggle('is-open', on);
      if (!on) { trigger.removeAttribute('aria-activedescendant'); list.removeAttribute('aria-activedescendant'); rising = false; clearTimeout(riseTimer); }
      else if (!sheet) { rising = true; clearTimeout(riseTimer); riseTimer = setTimeout(landed, 360); }   /* transitionend fallback (reduced motion, hidden tab) */
    };

    /* ------------------------------------------------------------------ THE SHEET (P27-7) */
    var door = null, doorSheet = null, doorBody = null, inerted = [];
    var buildDoor = function () {
      if (door) return;
      door = el('div', 'svnty-picker-door'); door.hidden = true;
      var layer = el('div', 'svnty-picker-door__layer');
      doorSheet = el('div', 'svnty-picker-door__sheet'); doorSheet.setAttribute('role', 'dialog'); doorSheet.setAttribute('aria-modal', 'true'); doorSheet.tabIndex = -1;
      var head = el('div', 'svnty-picker-door__head');
      var title = el('p', 'svnty-picker-door__title', root.getAttribute('data-picker-title') || placeholder);
      title.id = id + '-sheet-title'; doorSheet.setAttribute('aria-labelledby', title.id);
      var close = el('button', 'svnty-picker-door__close'); close.type = 'button'; close.setAttribute('aria-label', 'Close');
      if (closeTpl && closeTpl.content) close.appendChild(closeTpl.content.cloneNode(true)); else close.textContent = 'Close';
      close.addEventListener('click', function () { shut(true); });
      head.appendChild(title); head.appendChild(close);
      doorBody = el('div', 'svnty-picker-door__body');
      doorSheet.appendChild(head); doorSheet.appendChild(doorBody); layer.appendChild(doorSheet); door.appendChild(layer);
      layer.addEventListener('click', function (e) { if (e.target === layer) shut(true); });
      door.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); shut(true); return; }
        if (e.key === 'Tab') {   /* the page behind is inert; this keeps Tab inside the sheet in engines without inert */
          e.preventDefault(); if (document.activeElement === list) close.focus(); else list.focus({ preventScroll: true });
        }
      });
    };
    var inert = function (on) {
      if (on) {
        inerted = [];
        var node = door;
        while (node && node.parentElement && node !== document.body) {
          var parent = node.parentElement;
          Array.prototype.forEach.call(parent.children, function (sib) {
            if (sib === node || sib.inert || sib.tagName === 'SCRIPT' || sib.tagName === 'STYLE') return;
            sib.inert = true; inerted.push(sib);
          });
          node = parent;
        }
      } else { inerted.forEach(function (n) { n.inert = false; }); inerted = []; }
    };
    /* Escape shuts the sheet wherever the focus stands (a tap may leave it on the page's body) */
    var onDocKey = function (e) { if (sheet && e.key === 'Escape') { e.preventDefault(); shut(true); } };
    var openSheet = function (startAt) {
      buildDoor();
      sheet = true;
      var host = document.querySelector('.header-wrapper .header') || document.querySelector('.header-wrapper') || document.body;
      host.appendChild(door); door.classList.add('svnty-door');
      list.style.maxHeight = '';
      doorBody.appendChild(list);
      render(); setOpen(true);
      door.hidden = false;
      document.body.classList.add('overflow-hidden');
      inert(true);
      document.addEventListener('keydown', onDocKey, true);
      void door.offsetWidth;
      requestAnimationFrame(function () { door.classList.add('is-open'); });
      active = typeof startAt === 'number' ? startAt : (value ? indexOf(value) : 0);
      paintActive();
      requestAnimationFrame(function () { requestAnimationFrame(function () { try { list.focus({ preventScroll: true }); } catch (e) { list.focus(); } if (rows[active]) keepInView(rows[active]); }); });
    };
    var shut = function (focusTrigger) {
      if (!sheet) return;
      document.removeEventListener('keydown', onDocKey, true);
      door.classList.remove('is-open'); door.hidden = true;
      inert(false);
      document.body.classList.remove('overflow-hidden');
      riseInner.appendChild(list);
      if (door.parentNode) door.parentNode.removeChild(door);
      door.classList.remove('svnty-door');
      sheet = false;
      setOpen(false);
      if (focusTrigger) { try { trigger.focus({ preventScroll: true }); } catch (e) { trigger.focus(); } }
    };

    var openList = function (startAt) {
      if (open || trigger.disabled) return;
      if (phone() && natural() > 0.6 * (window.innerHeight || 800)) { openSheet(startAt); return; }
      render(); fit(true); setOpen(true);
      setActive(typeof startAt === 'number' ? startAt : (value ? indexOf(value) : 0));
    };
    var close = function (focusTrigger) {
      if (!open) return;
      if (sheet) { shut(focusTrigger); return; }
      setOpen(false); if (focusTrigger) trigger.focus({ preventScroll: true });
    };
    var pick = function (i) {
      if (i < 0 || i >= options.length) return;
      var changed = options[i].value !== value;
      value = options[i].value; input.value = value;
      paintTrigger();
      close(true);
      if (changed) root.dispatchEvent(new CustomEvent('svnty:picker:change', { bubbles: true, detail: { value: value, label: options[i].label } }));
    };
    var typeAhead = function (ch) {
      var now = Date.now();
      var same = typed.length === 1 && ch === typed && now - typedAt < TYPE_MS;
      typed = now - typedAt < TYPE_MS ? typed + ch : ch; typedAt = now;
      var q = (same ? ch : typed).toLowerCase();
      var start = same ? active + 1 : 0, n = options.length;
      for (var k = 0; k < n; k++) {
        var i = (start + k) % n;
        if (String(options[i].label).toLowerCase().indexOf(q) === 0) { if (!open) openList(i); else setActive(i); return; }
      }
    };
    var keys = function (e, fromList) {
      var k = e.key;
      if (k === 'Tab') { if (!fromList) close(false); return; }
      if (k === 'Escape') { if (open) { e.preventDefault(); close(true); } return; }
      if (!open) {
        if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Enter' || k === ' ' || k === 'Home' || k === 'End') {
          e.preventDefault(); openList(k === 'Home' ? 0 : k === 'End' ? options.length - 1 : undefined); return;
        }
      } else {
        if (k === 'ArrowDown') { e.preventDefault(); setActive(active + 1); return; }
        if (k === 'ArrowUp') { e.preventDefault(); setActive(active - 1); return; }
        if (k === 'Home') { e.preventDefault(); setActive(0); return; }
        if (k === 'End') { e.preventDefault(); setActive(options.length - 1); return; }
        if (k === 'PageDown') { e.preventDefault(); setActive(active + PAGE); return; }
        if (k === 'PageUp') { e.preventDefault(); setActive(active - PAGE); return; }
        if (k === 'Enter' || k === ' ') { e.preventDefault(); pick(active); return; }
      }
      if (k.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey && k !== ' ') { e.preventDefault(); typeAhead(k); }
    };

    trigger.addEventListener('click', function () { if (open) close(false); else openList(); });
    trigger.addEventListener('keydown', function (e) { keys(e, false); });
    list.addEventListener('keydown', function (e) { if (sheet) keys(e, true); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest ? e.target.closest('.svnty-picker__opt') : null;
      if (li) pick(Number(li.dataset.index));
    });
    list.addEventListener('mousemove', function (e) {
      var li = e.target.closest ? e.target.closest('.svnty-picker__opt') : null;
      if (li && Number(li.dataset.index) !== active) { active = Number(li.dataset.index); for (var i = 0; i < rows.length; i++) rows[i].classList.toggle('is-active', i === active); }
    });
    document.addEventListener('pointerdown', function (e) { if (open && !sheet && !root.contains(e.target)) close(false); });
    document.addEventListener('focusin', function (e) { if (open && !sheet && !root.contains(e.target)) close(false); });
    window.addEventListener('resize', function () { if (open && !sheet) fit(false); });

    root.svntyPicker = {
      setOptions: function (next) {
        options = (next || []).map(function (o) { return { value: String(o.value), label: String(o.label), hint: o.hint ? String(o.hint) : '', group: o.group ? String(o.group) : '' }; });
        if (value && indexOf(value) === -1) { value = ''; input.value = ''; }
        if (open) { render(); setActive(value ? indexOf(value) : 0); }
        paintTrigger();
      },
      setValue: function (v) {   /* programmatic: silent, so a prefill never reads as the customer's own pick */
        v = String(v == null ? '' : v);
        value = v && indexOf(v) !== -1 ? v : '';
        input.value = value; paintTrigger();
        if (open) render();
      },
      getValue: function () { return value; },
      getLabel: function () { return labelOf(value); },
      getOptions: function () { return options.slice(); },
      open: function () { openList(); },
      close: function () { close(false); },
      isOpen: function () { return open; },
      isSheet: function () { return sheet; },
      setDisabled: function (on) { trigger.disabled = !!on; input.disabled = !!on; root.classList.toggle('is-disabled', !!on); if (on) close(false); }
    };
    paintTrigger();
    setOpen(false);
  }
  var init = function () { document.querySelectorAll('[data-svnty-picker]').forEach(setup); };
  window.SVNTYPicker = { setup: setup };
  init();
  document.addEventListener('shopify:section:load', init);
})();
